export const SET_CURRENT_ASSIGNMENT = 'set_current_assignment';
export const ADD_ASSIGNMENTS = 'add_assignments';
export const RESET_CURRENT_ASSIGNMENT = 'reset_current_assignment';
export const SET_EXPORT_ASSIGNMENT_DATA = 'set_export_assignment_data';
export const RESET_EXPORT_ASSIGNMENT_DATA = 'reset_export_assignment_data';
export const SET_EXPORT_ASSIGNMENT_DETAIL_DATA = 'set_export_assignment_detail_data';
export const SET_EXPORT_ASSIGNMENT_DETAIL = 'set_export_assignment_detail';
export const RESET_EXPORT_ASSIGNMENT_DETAIL_DATA = 'reset_export_assignment_detail_data';
